import config from '@/config/config';
import contract from './contract';
import accessoryupload from './accessortUpload';
import elebill from './elebill';
import registration from './registration';
import productionTax from './productionTax';
import eleaccount from './ele-account';

const baseURL = config.baseURL;
const baseApi = {
  baseURL: baseURL,
  // 图片上传
  upload: config.uploadURL,
  // 图片上传 获取ticket
  getUploadTicket: config.baseURL + '/common/file/getToken',
  // 登录
  login: baseURL + '/common/user/login',
  // 租户列表
  tenantList: baseURL + '/common/user/tenant',
  // 切换租户
  changeTenant: baseURL + '/common/user/selectTenant',
  getUserMenuTree: '',
  lbsLocationParse: '',
  wechatResourceMedia: '',
  wechatResourceSign: ''
};

// 导出全部api
const api = { ...baseApi, ...contract, ...accessoryupload, ...elebill, ...registration, ...productionTax,...eleaccount };

export default api;
